import { Theme } from '@mui/material';
import { SxProps } from '@mui/material/styles';

export const getStyles = (theme: Theme): Record<string, Record<string, SxProps<Theme>>> => ({
  link: {
    '&.MuiBox-root': {
      outline: 'none',
      boxShadow: 'none',
    },
    '&.MuiBox-root:focus, &.MuiBox-root:focus-visible, &.MuiBox-root.Mui-focused': {
      outline: `2px solid ${theme.palette.action.focus}`,
      outlineOffset: '-4px',
      borderRadius: '6px',
      boxShadow: 'none',
    },
  },
});
